
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ element: Element, ...rest }) => {
  const auth = sessionStorage.getItem("token");
  const location = useLocation();

  if (!auth) {
    const redirect = encodeURIComponent(
      `${location.pathname}${location.search || ""}`
    );
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  return <Element {...rest} />;
};

export default PrivateRoute;
